import SvgIcon from '../SvgIcon'

export const ConsentButton = ({ onClick, classnames, type }) => {
  return (
    <button className={classnames} onClick={onClick}>
      {type === 'info' ? 'Ok' : <SvgIcon name="closeModal" />}
    </button>
  )
}
